<app-call-waiter-indicator
  class="bell"
  [active]="callWaiterMain()"
/>

<div class="content" [class.active]="!callWaiterMain()">
  <span>{{ 'serviceCenter.callWaiter' | translate }}</span>
</div>

<div class="content small" [class.active]="callWaiterMain()">
  <span>{{ 'serviceCenter.callWaiterCancel' | translate }}</span>
</div>
